import { render, staticRenderFns } from "./ObrigadoTarot.vue?vue&type=template&id=e53d96ce"
import script from "./ObrigadoTarot.vue?vue&type=script&lang=js"
export * from "./ObrigadoTarot.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoTarot.vue?vue&type=style&index=0&id=e53d96ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports